<template>
  <div class="gb-page">
    <HeadNav selectedLanguage="en" :page="pageKey" />
    <BreadcrumbNav :items="[{ label: page.title }]" />

    <main class="legal-main">
      <div class="page-shell">
        <article class="legal-article">
          <p class="eyebrow">{{ brand }}</p>
          <h1>{{ page.title }}</h1>
          <p class="updated">Last updated: July 2026</p>

          <section v-for="section in page.sections" :key="section.heading">
            <h2>{{ section.heading }}</h2>
            <p v-for="text in section.paragraphs" :key="text">{{ text }}</p>
          </section>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue'
import BreadcrumbNav from '@/components/BreadcrumbNav.vue'
import { footerPages } from '@/content/gbwapps'
import { SITE_BRAND } from '@/config/site'
import '@/css/base.scss'

export default {
  name: 'FooterPage',
  components: {
    HeadNav,
    BreadcrumbNav,
  },
  data() {
    return {
      brand: SITE_BRAND,
    }
  },
  computed: {
    pageKey() {
      return this.$route.meta.pageKey || 'about'
    },
    page() {
      return footerPages[this.pageKey] || footerPages.about
    },
  },
}
</script>

<style lang="scss" scoped>
.gb-page {
  background: #f6faf8;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.65;
  -webkit-font-smoothing: antialiased;
}

.page-shell {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
}

.legal-main {
  padding: 52px 0 70px;
}

.legal-article {
  padding: 38px;
  background: #ffffff;
  border: 1px solid #dce9e2;
  border-radius: 8px;
}

.eyebrow {
  margin: 0 0 10px;
  color: #0f8f43;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 34px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0;
}

.updated {
  margin: 12px 0 28px;
  color: #60746b;
}

section {
  margin-top: 28px;
}

h2 {
  margin: 0 0 12px;
  color: #000000;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0;
}

p {
  color: #222222;
  line-height: 1.625;
}

@media (max-width: 640px) {
  .legal-article {
    padding: 24px 18px;
  }

  h1 {
    font-size: 28px;
  }
}
</style>
